import styled from 'styled-components';

import Link from 'components/Link';

export const StyledLink = styled(Link)`
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
  overflow: hidden;
`;

export const LinkWrapper = styled.div`
  width: 100%;
`;
